import React, { forwardRef } from 'react';
import {
  SelectProps as MuiSelectProps,
  Select as MuiSelect,
  FormControl,
  FormHelperText,
  InputLabel,
} from '@mui/material';
import { WBBox, WBView } from '../..';
export type SelectV2Props = MuiSelectProps & {
  error?: boolean;
  helperText?: string;
  label?: string;
};

export const SelectV2 = forwardRef<any, SelectV2Props>(
  ({ fullWidth, label, ...otherProps }, ref) => {
    const [isOpen, setIsOpen] = React.useState(false);
    return (
      // <FormControl fullWidth={fullWidth}
      // variant='standard'>
      <WBView>
        <InputLabel
          shrink={false}
          id={`${otherProps.name}-label`}
          sx={{ marginTop: label ? 1 : 0 }}
        >
          {label}
        </InputLabel>
        <MuiSelect
          ref={ref}
          variant="standard"
          onOpen={() => setIsOpen(true)}
          onClose={() => setIsOpen(false)}
          fullWidth={fullWidth}
          {...otherProps}
          label={label}
          labelId={`${otherProps.name}-label`}
          displayEmpty
          {...(!otherProps.value && otherProps.placeholder
            ? {
                renderValue: (selected: any, ...params) => {
                  if (selected === '' || selected?.length === 0) {
                    return <span>{otherProps.placeholder}</span>;
                  }
                  return selected;
                },
              }
            : null)}

          // IconComponent={(iconProps) =>
          //   !isOpen ? (
          //     <Icon name="ChevronDown" {...iconProps} size={'large'} />
          //   ) : (
          //     <Icon name="ChevronUp" {...iconProps} size={'large'} />
          //   )
          // }
        />
        <FormHelperText id={otherProps.id} error={otherProps.error}>
          {otherProps.helperText}
        </FormHelperText>
      </WBView>
    );
  }
);
